import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { CSSProperties, ReactNode } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';

import { Skeleton } from '@feathr/components';

import * as styles from './TLDR.css';

import noImg from '@feathr/extender/images/no-img.png';

interface IPropsLoading {
  className?: string;
  image?: ReactNode;
  isLoading: true;
  link?: string;
  children?: ReactNode;
  rowReverse?: boolean;
}
interface IPropsLoaded {
  className?: string;
  image: ReactNode;
  isLoading: false;
  link?: string;
  children: ReactNode;
  rowReverse?: boolean;
}

interface ICustomCSSProperties extends CSSProperties {
  '--l-flex-direction'?: string;
}

function TLDR({
  children,
  className,
  image,
  isLoading = false,
  link,
  rowReverse = false,
}: IPropsLoading | IPropsLoaded) {
  const style: ICustomCSSProperties = {};
  if (!!rowReverse) {
    style['--l-flex-direction'] = 'row-reverse';
  }

  if (isLoading) {
    return (
      <article className={classNames(styles.root, className)}>
        {/* Uses three paragraphs to fill the component's space appropriately */}
        {/* Add prefix or suffix based on creatives being flipped */}
        <Skeleton paragraphs={3} prefix={!rowReverse} suffix={rowReverse} width={260} />
      </article>
    );
  }

  const item = (
    <article className={classNames(styles.root, className)} style={style}>
      {typeof image === 'string' || !image ? (
        <img alt={''} className={styles.image} src={(image as string) || noImg} />
      ) : (
        image
      )}
      {typeof children === 'string' ? <span>{children}</span> : children}
    </article>
  );

  if (link) {
    return (
      <Link className={styles.link} to={link}>
        {item}
      </Link>
    );
  }

  return item;
}

export default observer(TLDR);
